import Button from "../../components/button/button.component";
import { NavLink } from "../../components/navbar/navbar.component";
import "./home.css";
import CV from "../../assets/Tshepiso Motsumi UXUI Designer.pdf";

function Home() {
  const scrollToSocials = () => {
    const section = document.getElementById(NavLink.SOCIALS);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <div className="page page-padding col-12 d-flex align-items-center px-3">
      <div
        className="home-page d-flex col-12 flex-column justify-content-md-center justify-content-sm-start align-items-center py-5 px-3"
        id={NavLink.HOME}
      >
        <div className="fs-1 sub-front-1 font-bold py-3">UX/UI DESIGNER</div>
        <div className="fs-4 text-center font-bold sub-front-2">
          Designing with empathy to connect people and technology
        </div>
        <div className="fs-6 text-center font-bold sub-front-1 py-3">
          I’m a UX/UI designer who creates intuitive and empathetic digital
          experiences that put people first.
        </div>
        <div className="d-flex padding-v-10">
          <div className="padding-h-10 no-padding-left">
            <a href={CV} download="Tshepiso Motsumi - UX Designer.pdf">
              <Button text="Download CV" />
            </a>
          </div>
          <div className="padding-h-10 no-padding-right">
            <Button
              text="Let's Connect"
              isDark={true}
              onClick={scrollToSocials}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
